import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';

import { getUrlParam } from '~globals/common';

import CardBlogImage from './CardBlogImage';

export type CardBlogPostProps = {
    title: string;
    body: string;
    imageurl: string;
    index: number;
    backgroundsurface: SupportedBackgroundColor;
    textcolor: SupportedTextColor;
    minwidths: string;
    bannertype?: 'Coming Soon';
    url?: string;
    urlflag?: 'DSNP';
};

const CardBlogPost = forwardRef(function RefCard(
    {
        imageurl,
        title,
        body,
        index,
        backgroundsurface,
        textcolor,
        minwidths,
        bannertype,
        url,
        urlflag,
    }: CardBlogPostProps,
    ref: ForwardedRef<HTMLDivElement | null>
) {
    const doesRenderWithCurrentFlag = () => {
        if (!urlflag) {
            return true;
        }
        if (urlflag.includes(':hide')) {
            const actualFlag = urlflag.replace(':hide', '');
            return getUrlParam(actualFlag) !== 'true';
        }
        return getUrlParam(urlflag) === 'true';
    };

    const trackingComponentName = 'Card Blog Post';

    if (!doesRenderWithCurrentFlag()) return null;

    return (
        <div
            ref={ref}
            className={classNames(
                'blog-card-container relative',
                'flex flex-col h-full items-center justify-start self-stretch',
                'h-[235px] md:h-[255px] lg:h-[295px]',
                'mb-2 shadow rounded text-center',
                'overflow-hidden',
                'snap-center md:snap-align-none',
                minwidths,
                backgroundsurface,
                textcolor
            )}
            data-index={index}
        >
            {bannertype && (
                <div
                    className={classNames(
                        'bg-icon-primary text-white font-bold',
                        'transform rotate-45 leading-24',
                        'absolute top-8 -right-20 md:-right-24 lg:-right-28 w-full'
                    )}
                >
                    {bannertype}
                </div>
            )}
            <a
                className="flex h-40 items-center justify-center min-h-40 object-center overflow-hidden w-full"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                title={title}
                data-wa-link={`click: ${trackingComponentName}: ${url}: img`}
            >
                <CardBlogImage
                    src={imageurl}
                    loading="lazy"
                    alt={title}
                    title={title}
                    className="object-cover min-h-40 w-full"
                />
            </a>
            <div className="pt-3 px-4 mb-auto">
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 text-link font-normal text-14 leading-20 md:font-semibold lg:text-18 lg:leading-28 no-underline"
                    data-wa-link={`click: ${trackingComponentName}: ${url}: title`}
                    data-qa={`article_${index + 1}_employer_health_information`}
                >
                    {title}
                </a>
            </div>
            {body && <p>{body}</p>}
        </div>
    );
});

CardBlogPost.displayName = 'CardBlogPost';

export default CardBlogPost;
